export const ADS_NPS_RATING_DIALOG_SKIP = 'ads-nps-rating-dialog-skip'
